var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "experiences-filter-wrapper" },
    [
      _c("simple-list", {
        ref: "list",
        staticClass: "experience-list",
        class: { scroller: _vm.isScrollable },
        attrs: {
          "server-items": _vm.availableExperiences,
          query: "categories.label",
          "undefined-value": _vm.dictionary.allExperiences,
          variant: _vm.isScrollable
            ? "experience-list-scrollable"
            : "experience-list",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "filter",
              fn: function (ref) {
                var filters = ref.filters
                return [
                  _c(
                    "div",
                    { staticClass: "experience-list-header" },
                    [
                      _c("accessible-tabs", [
                        _c(
                          "div",
                          {
                            staticClass: "filter-items",
                            attrs: { role: "tablist" },
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "filter-item tab-group-button",
                                class: [{ active: !_vm.currentCategory }],
                                attrs: {
                                  id: "exp-filter-all",
                                  type: "button",
                                  role: "tab",
                                  "aria-selected": !_vm.currentCategory,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.filterCategory($event)
                                  },
                                  keydown: [
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "right",
                                          39,
                                          $event.key,
                                          ["Right", "ArrowRight"]
                                        )
                                      ) {
                                        return null
                                      }
                                      if (
                                        "button" in $event &&
                                        $event.button !== 2
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      return _vm.filterCategory(
                                        $event,
                                        _vm.categories[0].label
                                      )
                                    },
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "left",
                                          37,
                                          $event.key,
                                          ["Left", "ArrowLeft"]
                                        )
                                      ) {
                                        return null
                                      }
                                      if (
                                        "button" in $event &&
                                        $event.button !== 0
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      return _vm.filterCategory(
                                        $event,
                                        _vm.categories[
                                          _vm.categories.length - 1
                                        ].label
                                      )
                                    },
                                  ],
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.dictionary.allExperiences)),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.categories, function (category, i) {
                              return _c(
                                "button",
                                {
                                  key: category.label,
                                  staticClass: "filter-item tab-group-button",
                                  class: [
                                    {
                                      active:
                                        _vm.currentCategory === category.label,
                                      disabled: _vm.categoryIsDisabled(
                                        category.label
                                      ),
                                    },
                                  ],
                                  attrs: {
                                    id: "exp-filter-" + i,
                                    type: "button",
                                    role: "tab",
                                    "aria-selected":
                                      _vm.currentCategory === category.label,
                                    tabindex:
                                      filters["categories.label"] ===
                                        category.label &&
                                      !_vm.categoryIsDisabled(category.label)
                                        ? "0"
                                        : "-1",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.filterCategory(
                                        $event,
                                        category.label
                                      )
                                    },
                                    keydown: [
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "right",
                                            39,
                                            $event.key,
                                            ["Right", "ArrowRight"]
                                          )
                                        ) {
                                          return null
                                        }
                                        if (
                                          "button" in $event &&
                                          $event.button !== 2
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        return _vm.filterCategory(
                                          $event,
                                          i === _vm.categories.length - 1
                                            ? null
                                            : _vm.categories[i + 1].label
                                        )
                                      },
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "left",
                                            37,
                                            $event.key,
                                            ["Left", "ArrowLeft"]
                                          )
                                        ) {
                                          return null
                                        }
                                        if (
                                          "button" in $event &&
                                          $event.button !== 0
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        return _vm.filterCategory(
                                          $event,
                                          i === 0
                                            ? null
                                            : _vm.categories[i - 1].label
                                        )
                                      },
                                    ],
                                  },
                                },
                                [_c("span", [_vm._v(_vm._s(category.label))])]
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.showExperiencesFilter
                        ? _c("experiences-filter", {
                            ref: "experienceFilter",
                            attrs: {
                              experiences: _vm.experiences,
                              "experience-type-filter": filters,
                              options: _vm.options,
                              dictionary: _vm.dictionary,
                            },
                            on: {
                              updateFilteredExperiences:
                                _vm.updateExperiencesAvailable,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var activate = ref.activate
                                    var isActive = ref.isActive
                                    var resetAllFilters = ref.resetAllFilters
                                    var totalFiltersSelected =
                                      ref.totalFiltersSelected
                                    return _c(
                                      "button",
                                      {
                                        staticClass:
                                          "experiences-filter--activator",
                                        class: totalFiltersSelected
                                          ? "filter-selected"
                                          : "",
                                        on: { click: activate },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "experiences-filter--activator-label",
                                            class: totalFiltersSelected
                                              ? "filter-selected"
                                              : "",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.dictionary.filter)
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        totalFiltersSelected > 0
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "experiences-filter--activator-total-tag",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(totalFiltersSelected)
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "icon-filter-black",
                                        }),
                                        _vm._v(" "),
                                        totalFiltersSelected > 0
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "experiences-filter--activator-reset",
                                                attrs: {
                                                  tabindex: isActive
                                                    ? "-1"
                                                    : "0",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return resetAllFilters(
                                                      $event
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      _vm.dictionary.reset
                                                    ) +
                                                    "\n            "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "no-items",
              fn: function () {
                return [
                  _c("div", { staticClass: "error-box no-margin" }, [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.dictionary.noResultMessage) +
                          "\n        "
                      ),
                    ]),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "rendered-list",
              fn: function (ref) {
                var items = ref.items
                return [
                  _c(
                    "ul",
                    _vm._l(items, function (item) {
                      return _c(
                        "li",
                        {
                          key: item.id,
                          staticClass: "experience-card-wrapper",
                        },
                        [
                          _c("experience-card", {
                            attrs: {
                              experience: item,
                              filter: _vm.currentCategory,
                              dictionary: _vm.dictionary,
                              "eyebrow-source": _vm.options.eyebrowSource,
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              },
            },
            !_vm.isScrollable
              ? {
                  key: "pagination",
                  fn: function (ref) {
                    var pagination = ref.pagination
                    var defaultLimit = ref.defaultLimit
                    var allLoaded = ref.allLoaded
                    return [
                      _c(
                        "div",
                        { staticClass: "pagination" },
                        [
                          _c(
                            "load-more-pagination",
                            _vm._b(
                              {
                                attrs: {
                                  variant: "experience-list",
                                  "load-more-text": _vm.dictionary.loadMore,
                                },
                                model: {
                                  value: pagination,
                                  callback: function ($$v) {
                                    pagination = $$v
                                  },
                                  expression: "pagination",
                                },
                              },
                              "load-more-pagination",
                              {
                                defaultLimit: defaultLimit,
                                allLoaded: allLoaded,
                              },
                              false
                            )
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                }
              : null,
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }